<template>
  <div>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <!-- 卡片-主体-表单-表格数据筛选 -->
        <div class="md-layout card-form" style="max-width: 600px;">
          <!-- 表单-选择栏-参数类型 -->
          <div class="md-layout-item md-size-40 left-layout-item">
            <md-field>
              <md-select v-model="formData.searchType">
                <md-option :value="'ip'">{{"IP"}}</md-option>
                <md-option :value="'zone'">{{$I18n('belong_areas')}}</md-option>
                <md-option :value="'region'">{{$I18n('belong_co')}}</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- 表单-输入栏-参数值 -->
          <div class="md-layout-item md-size-40 left-layout-item" style="position: relative;">
            <md-field>
              <label v-if="formData.searchType === 'ip'">{{"IP"}}</label>
              <label v-if="formData.searchType === 'zone'">{{$I18n("belong_areas")}}</label>
              <label v-if="formData.searchType === 'region'">{{$I18n("belong_co")}}</label>
              <template>
                <md-input v-if="formData.searchType === 'ip'" v-model="formData.searchValue"/>
                <md-select v-else-if="formData.searchType === 'region'" v-model="formData.searchValue">
                  <md-option value="ALL">{{$I18n("all")}}</md-option>
                  <md-option v-for="item in continentArray" :key="'main_'+item.code" :value="item.code">
                    {{$router.history.current.query.lang === "zh" ?item.cn_name :item.name}}
                  </md-option>
                </md-select>
                <template v-else>
                  <md-select v-model="formData.searchValue">
                    <md-option value="ALL">{{$I18n("all")}}</md-option>
                    <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                      $router.history.current.query.lang === "zh" ?item.cn_name :item.name
                    }}</md-option>
                  </md-select>
                  <div @click="$refs.zone_s.open()" style="position:absolute; top: 0; bottom: 0;left: 0; right: 0;z-index: 1;cursor: pointer;"/>
                </template>
              </template>
            </md-field>
          </div>
          <div class="md-layout-item md-size-20">
            <md-button class= "left-icon md-info" @click="form_search">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <add-button @click="() => table_addItem()">{{$I18n("add")}}</add-button>
          </div>
        </div>
        <md-table v-model="tableData">
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
            <md-table-cell :md-label="$I18n('belong_company')">{{ item.comp_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('zone')">{{ item.zone_name }}<br/>{{item.region_name}}</md-table-cell>
            <md-table-cell :md-label="'IP'">{{ item.ip }}<br/>{{item.local_ip }}</md-table-cell>
            <!-- <md-table-cell :md-label="$I18n('local_ip')">{{ item.local_ip }}</md-table-cell> -->
            <md-table-cell :md-label="$I18n('mac')">{{ item.mac }}</md-table-cell>
            <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('erate')">{{ item.erate }}</md-table-cell>
            <md-table-cell :md-label="$I18n('update_date')">{{ item.update_date }}</md-table-cell>
            <md-table-cell :md-label="$I18n('create_time')">{{ item.create_date }}</md-table-cell>
            <!-- <md-table-cell :md-label="('Key')">{{ item.key }}</md-table-cell> -->
            <md-table-cell :md-label="$I18n('operate')"  class="button-box">
              <md-button @click="table_editItem(item)" class="md-just-icon md-round md-info left-icon">
                <md-icon>edit</md-icon>
              </md-button >
              <md-button @click="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info" >
                <md-icon>close</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
        </md-table>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="pageNo"/>
      </md-card-content>
    </md-card>
    <!-- 弹窗 -->
    <simple-modal 
      ref        = "modal"
      :title     = "modalTitle"
      :right     = "openModalType!=='delete'"
      :large     = "openModalType==='import'"
      :submitBtn = "openModalType!=='import'"
      @submit    = "modal_submit"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.ip)}}</div>
        <!-- 修改/添加弹窗 -->
        <div class="md-layout" v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field  v-if="item.keys === 'zone'" :class="{'md-error':modalData.Error.zone_name}">
              <md-input @click="$refs.zone.open()" :style="{'width':'100%'}" v-model="modalData.Form.zone_name"/>
              <!-- 错误ICON -->
              <md-icon v-if="modalData.Error.zone_name">clear</md-icon>
            </md-field>
          </common-form-item>
          <div v-if="openModalType==='edit'" style="width: 100%;padding:10px 30px 0;text-align: left;">
            <md-table v-model="server_tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="$I18n('server_name')">{{ item.type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('version')">{{ item.ver }}</md-table-cell>
                <md-table-cell :md-label="$I18n('status')">
                  <md-field style="margin-top:0 !important; padding-bottom: 10px !important;">
                    <md-select v-model="item.state">
                      <md-option :value="1">{{$I18n("inline")}}</md-option>
                      <md-option :value="2">{{$I18n("offline")}}</md-option>
                      <md-option :value="3">{{$I18n("wait_auth")}}</md-option>
                      <md-option :value="4">{{$I18n("outline")}}</md-option>
                    </md-select>
                  </md-field>
                </md-table-cell>
                <md-table-cell :md-label="$I18n('latest_timestamp')">{{ item.update_date }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')"  class="button-box small">
                  <md-button @click="open_del_svr(item)" class="md-just-icon md-round md-danger md-info" >
                    <md-icon>close</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
            <!-- 翻页 -->
            <!-- <table-page :total="svr_total" :pageSize="svr_pageSize" v-model="svr_pageNo"/> -->
          </div>
        </div>
      </template>
    </simple-modal>
    <simple-modal 
      ref        = "del_modal"
      :title     = "$I18n('delete')"
      :right     = "false"
      :large     = "false"
      @submit    = "api_delSev"
    >
      <div slot="body">
        <!-- del_svr_item.id + " " +  -->
        {{$I18n("check_delete", del_svr_item.type_name)}}
      </div>
    </simple-modal>
    <zone-select-modal ref="zone_s" @select="zone => (formData.searchValue = zone)"/>
    <zone-select-modal ref="zone" @select="changeModalZone"/>
  </div>
</template>
<script>
import { FormClass, timestampToString1000 } from "@/common/tools.js";
import { countryMap, continentMap } from "@/common/continent.js";
import ZoneSelectModal from "@/components/Common/ZoneSelectModal";
import {countryArray, continentArray} from "@/common/continent.js";

export default {
  components: {
    ZoneSelectModal,
  },
  // props: ["userinfo_sys"],
  data() {
    return {
      countryArray,
      continentArray,
      show_zone : "",
      formData  : {
        searchType : "ip",
        searchValue: "",
      },
      searchData: {
        ip: "",
        region:"",
        zone:"",
      },

      companys : [],
      // Table 原始数据 (翻页)
      tableInitData: [],
      pageNo   : 1,
      total    : 0,

      // 每页的数量(统一)
      pageSize: 10,
      // 弹窗相关
      openModal     : false, // 是否打开弹窗
      openModalType : "",    // 弹窗类型
      modalTitle    : "",    // 弹窗标题
      // 弹窗表单相关
      modalData : new FormClass({
        zone   :{
          init :"",
          check:"required",
        },
        zone_name   :{
          init :"",
          check:"required",
        },
        region   :{
          init :"",
          check:"required",
        },
        ip     :{
          init : "",
          check: "required",
        },
        local_ip:{
          init : "",
          check: "required",
        },
        comp_id :{
          init : this.UserInfo.comp_id,
          check: "required",
        },
        erate :{
          init : "90",
          check: "required",
        },
      }),

      server_tableData: [],
      server_tableInitData: [],
      svr_id      : 0,
      svr_total   : 0,
      // svr_pageNo  : 1,
      // svr_pageSize: 4,

      del_svr_item: {},
    };
  },
  watch: {
    'searchForm.Form.searchType':function() {
      this.searchForm.Form.searchValue = "";
    },
    pageNo(){
      this.api_getPageData();
    },
    // svr_pageNo(){
    //   this.api_getServerInfo();
    // },
    server_tableData_state:{
      handler(newV, oldV){
        if(!newV || !oldV ||newV.length !== oldV.length){
          return
        }
        newV.forEach((i, index) => {
          if(i !== oldV[index] && i > 0 && oldV[index] > 0){
            this.api_svrStateUpdate(index, i);
          }
        })
        return
      },
      immediate: true,
      deep: true,
    },
    server_tableInitData(newV){
      if(!newV){
        return
      }
      this.server_tableData = [...newV]
        .sort((itemA, itemB) => {
          if(itemA.type !== itemB.type){
            return itemA.type - itemB.type
          } else {
            return itemA.id - itemB.id
          }
        })
        .map(item => {
          let state_name = "";
          if(item.state === 1){
            state_name = this.$I18n("inline")
          } else if(item.state === 2){
            state_name = this.$I18n("offline")
          } else if(item.state === 3){
            state_name = this.$I18n("wait_auth")
          } else if(item.state === 4){
            state_name = this.$I18n("outline")
          }
          return {
            ...item,
            state_name,
            update_date : timestampToString1000(item.gmt_update),
          }
        })
    },
  },
  computed:{
    server_tableData_state(){
      return this.server_tableData.map(i => parseInt(i.state));
    },
    // 表格数据处理
    tableData(){
      return [...this.tableInitData]
        // .splice((this.pageNo-1) * this.pageSize, this.pageSize)
        .map(item => {
          const lang = this.$router.history.current.query.lang == "zh" ?"cn_name" :"name";
          // const comp_obj = this.companys.filter(i => i.comp_id == item.comp_id)[0];
          const zone_name   = countryMap[item.zone] ?countryMap[item.zone][lang] :"";
          const region_name = continentMap[item.region] ?continentMap[item.region][lang] :"";

          return {
            ...item,
            zone_name,
            region_name,
            state_name : item.state == 1 ?this.$I18n("normal") :this.$I18n("abnormal"),
            // comp_name: comp_obj?(comp_obj.comp_short_name ?comp_obj.comp_short_name :comp_obj.comp_name) :"",
            type_name: this.$Param.srvList.getName(item.type),
            update_date : timestampToString1000(item.gmt_update),
            create_date : timestampToString1000(item.gmt_create),
          }
        })
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          required: true,
          check   : true,
          options : this.companys.map(i => ({
            id  : i.comp_id,
            name: i.comp_short_name?i.comp_short_name :i.comp_name,
          })),
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("zone"),
          keys    : "zone",
          check   : true,
          required: true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("pub_ip"),
          keys    : "ip",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("local_ip"),
          keys    : "local_ip",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("erate"),
          keys    : "erate",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50",
        }
      ]
    },
  },
  mounted(){
    this.$api.getCompanyList({
      page_no  :1,
      page_size:9999,
    })
      .then(res => {
        this.companys = res.data;
        // if(res.data.length > 0){
        //   this.modalData.SetInit(res.data[0].comp_id, "comp_id");
        // }
        this.api_getPageData();
      })
  },
  methods: {
    api_delSev(){
      this.$api.delServerInfo({id : this.del_svr_item.id})
        .then(this.$Then(() => {
          this.$refs.del_modal.close();
          this.api_getServerInfo();
          this.$successMsg(this.$I18n("delete_success"))
        }))
        .catch(this.$Catch(this.$I18n("delete_fail")))
    },
    open_del_svr(item){
      this.del_svr_item = {...item};
      this.$refs.del_modal.open();
    },
    api_svrStateUpdate(index, state){
      this.$api.setServerInfo({
        id: this.server_tableData[index].id,
        state: state,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"))
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
    changeModalZone(zone, item){
      this.modalData.Form.zone      = item.code;
      this.modalData.Form.zone_name = this.$router.history.current.query.lang === "zh" ?item.cn_name :item.name;
      this.modalData.Form.region    = item.continent_code;
    },
    // 查询
    form_search() {
      const value = this.formData.searchValue === "ALL" ?"" :this.formData.searchValue
      this.searchData = {
        ...this.formData,
        sys      : this.userinfo_sys,
        region   : this.formData.searchType === 'region' ?value :"",
        zone     : this.formData.searchType === 'zone'   ?value :"",
        ip       : this.formData.searchType === 'ip'     ?value :"",
      };
      this.pageNo = 1;
      this.api_getPageData();
    },
    api_getServerInfo(){
      this.$api.getServerInfo({
        // page_size: this.svr_pageSize, // 因为获取的srv 排序不固定，不使用
        // page_no  : this.svr_pageNo, // 因为获取的srv 排序不固定，不使用
        page_size: 9999,
        page_no  : 1,
        svr_id   : this.svr_id,
      })
        .then(this.$Then(res => {
          this.server_tableInitData = res.data;
          this.svr_total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.server_tableInitData = [];
          this.svr_total = 0;
        }))
    },
    api_getPageData() {
      this.$api.getIpServer({
        ...this.searchData,
        page_no  : this.pageNo,
        page_size: this.pageSize,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))

        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 添加
    table_addItem(){
      this.openModalType = "add";
      this.modalData.Reset();
      this.modalTitle = this.$I18n("add");
      this.server_tableInitData=[];
      this.$refs.modal.open();
    },
    // 修改
    table_editItem(item){
      this.openModalType = "edit";
      this.modalData.Update(item);
      this.modalTitle = this.$I18n("edit");
      this.svr_id = item.id;
      // this.svr_pageNo = 1;
      this.api_getServerInfo();
      this.$refs.modal.open();
    },
    // 删除
    table_deleteItem(item){
      this.modalData.Update(item);
      this.openModalType = "delete";
      this.modalTitle = this.$I18n("delete");
      this.server_tableInitData=[];
      this.$refs.modal.open();
    },
    modal_submit(){
      if(this.openModalType === "delete"){ // 删除
        return this.$api.delIpServer({...this.modalData.Form,})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("delete_success"))
          }))
          .catch(this.$Catch(this.$I18n("delete_fail")))
      }
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      if(this.openModalType === "add"){
        this.$api.addIpServer({...this.modalData.Form,})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("add_success"))
          }))
          .catch(this.$Catch(this.$I18n("add_fail")))
      } else if (this.openModalType === "edit"){
        this.$api.editIpServer({...this.modalData.Form,})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("edit_success"))
          }))
          .catch(this.$Catch(this.$I18n("edit_fail")))
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .left-layout{
    padding-left: 0;
  }
  .right-layout{
    padding-right: 0;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .total-page{
    width: 30%;
    display: inline-block;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .button-box.small {
    width: 80px;
  }
  //左侧iocn
  .left-icon{
    margin-right: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>